<template>
  <VueCroppie
    ref="croppie"
    class="common-image-crop"
    :enableResize="false"
    :showZoomer="true"
    :viewport="{ width: 300, height: 300 }"
    @update="cropDebounced"
  />
</template>

<script>
import _debounce from 'lodash/debounce'
import { VueCroppieComponent as VueCroppie } from 'vue-croppie'

const bindOptions = {
  zoom: 0,
}

export default {
  components: { VueCroppie },
  props: {
    value: {
      type: [ File, String ],
      default: null,
    },
  },
  data: (vm) => ({
    cropDebounced: _debounce(vm.crop, 50),
  }),
  computed: {
    name () {
      if (!this.value) return this.value
      if (typeof this.value === 'string') {
        return this.value.split('/').pop().split('#')[0].split('?')[0]
      }
      return this.value.name
    },
  },
  watch: {
    value (value) {
      this.bind(value)
    },
  },
  mounted () {
    this.bind(this.value)
  },
  methods: {
    bind (fileOrUrl) {
      if (!fileOrUrl) return this.$refs.croppie.refresh()
      else if (typeof fileOrUrl === 'string') {
        const proxyUrl = 'https://cors-anywhere.herokuapp.com/'

        return this.$refs.croppie.bind({
          ...bindOptions,
          url: proxyUrl + fileOrUrl,
        })
      }
      const reader = new FileReader()

      reader.onload = e => {
        this.$refs.croppie.bind({
          ...bindOptions,
          url: e.target.result,
        })
      }
      reader.readAsDataURL(fileOrUrl)
    },
    crop () {
      this.$refs.croppie.result({ type: 'blob', size: 'original' }, (result) => {
        this.$emit('input', new File([ result ], this.name, { type: 'image/png' }))
      })
    },
  },
}
</script>

<style src="croppie/croppie.css"></style>

<style scoped>
  .common-image-crop {
    height: 400px;
    margin-bottom: 50px;
  }
  .common-image-crop /deep/ .cr-viewport {
    box-shadow: 0 0 2000px 2000px rgba(255, 255, 255, 0.5);
  }
</style>
